import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Button, Alert} from "react-bootstrap";

import api from "../../services/api";
import "./styles.css";

export default function ParticipanteNovo({ history }) {
    const [pessoa, setPessoa] = useState([]);
    const [nome, setNome]= useState('');
    const [email, setEmail]= useState('');
    const [instituicao, setInstituicao]= useState('');
    const [tipoInteresse]= useState('1');
    const [telefone, setTelefone]= useState('');
    const [celular, setCelular]= useState('');
    const [cpf, setCPF]= useState('');
    const { consulta_id } = useParams();
    const [idAudiencia] = useState(consulta_id);
    const [mensagem, setMensagem]= useState("");
    const [tipoMensagem, setTipoMensagem] = useState("danger");
    const [avisoEmail, setAvisoEmail] = useState(false);
    const [enviando, setEnviando] = useState(false);
 
    useEffect(() => {
      async function loadPessoa() {
        if (email && email.indexOf("@")>2) {
          const response = await api.get(`/api/pessoa/${email}/publico`);
          setPessoa(response.data[0]);
        }
      }
      loadPessoa();
    }, [email]);

    function handleCancelar() {
      if (idAudiencia>0){
        history.push(`/Consulta/${idAudiencia}`);
      } else {
        history.push(`/`);
      }
    }

    async function handleAEnviarNovo() {
      if (enviando) {
        return;
      }
      if (criticaNovoParticipante()){
        try {
          setTipoMensagem("info");
          setMensagem("Enviando os dados, por favor aguarde...");
          setEnviando(true);
          await salvaNovoParticipante();
          setTipoMensagem("success");
          setMensagem("Dados enviados com sucesso!");
        } catch (error) {
          setTipoMensagem("danger");
          setMensagem("Erro ao enviar os dados. Tente novamente mais tarde.");
        } finally {
          setEnviando(false);
        }
      }
    }
    function criticaNovoParticipante() {
      setTipoMensagem("danger");
      setMensagem("");
      var msg = "Erro: ";
      if (!nome || nome.length < 4){
        msg +="Nome é obrigatório; ";
      }
      if (!email || email.length < 4){
        msg +="E-mail é obrigatório; "
      }
      if (!cpf || cpf.length < 11){
        msg +="CPF é obrigatório, digite apenas os números; "
      }
      if (!criticaCPF()){
        msg +="CPF é inválido, digite apenas os números; "
      }
      if (!telefone || telefone.length < 4){
        msg +="Telefone é obrigatório; "
      }
      if (!instituicao || instituicao.length < 1){
        msg +="Instiruição é obrigatório; "
      }
      if (pessoa && pessoa.NO_EMAIL === email){
        msg +="Participante já cadastrado";
      }
      if (msg.length > 6){
        setMensagem(msg);
        return false;
      }
      else {
        return true;
      }
    }

    function criticaCPF(){
        let soma, digoriginal, dig1, dig2, aux;
        if (cpf.length===11){
          aux=cpf;
        } else {
          if (cpf.length===14){
            aux=cpf.substr(0,3)+cpf.substr(4,3)+cpf.substr(8,3)+cpf.substr(12,3)
          } else {
            return false;
          }
        }
        digoriginal=aux.substr(9,2);
        soma = 0;
        for (var i=0;i<=8;i++) {
          soma += (parseFloat(aux.substr(i,1)) * (10 - i));
        }
        dig1 = (((soma % 11 === 0) || (soma % 11 === 1)) ? 0 : 11 - (soma % 11));  
        soma = 0;
        for (i=0;i<=9;i++) {
          soma += parseFloat(aux.substr(i,1)) * (11 - i);
        }
        dig2 = (((soma % 11 === 0) || (soma % 11 === 1)) ? 0 : 11 - (soma % 11)); 
        if ((digoriginal.substr(0,1) === String(dig1)) && (digoriginal.substr(1,1) === String(dig2))){
          setCPF(aux);
          return (true);
        }
        else{
          return (false);
        }
    }

    async function salvaNovoParticipante() {
      const data = { 
        'Nome': nome,
        'Email': email,
        'Telefone': telefone, 
        'Celular': celular,
        'Instituicao': instituicao,
        'Interessado': tipoInteresse,
        'CPF': cpf,
        'Senha': null,
        'ReceberEmail': 'N',
      };
      const response = await api.post(
        `/api/pessoa`,
        data);
      return response;
      // enviaEmailConfirmacao(response.data[0].idToken);
    }
    async function enviaEmailConfirmacao(idToken){
      const data = { 
        'destinatario' : email, 
        'assunto' : "Confirmação de inscrição no Sistema de Participação Social das Decisões da ANA",
        'texto' : "",
        'html' : "<p><b>Sistema de Participação nas decisões da ANA</b></p>"+
                 "<br />"+
                 "<p>O n° de confirmação de sua inscrição é: "+idToken+"</p>"+
                 `Informe este n° de confirmação na página de <a href='https://participacao-social.ana.gov.br/confirma/${idToken}'>confirmação</a> `+
                 " e confirme  a sua inscrição.</p>"
       }
       await api.post(
        "/api/sendmail",
        data);
      setAvisoEmail(true);
    }
    function hancleConfirmar(){
      history.push(`/Confirma/0`);
    }
    return (
      <>
        <Container>
          <Row>
            <Col sm={12}>
              <div className="voltar">
                <a href={`/Consulta/${idAudiencia}`}>voltar</a>
              </div>
            </Col>
          </Row>
            <form id="formContribuinte">
              <div className={avisoEmail? "quadro naoMostrar":"quadro mostrar"}>
                <Row>
                  <Col sm="12">
                    <h3>Inscrição de Participante</h3>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <label htmlFor="Nome">Nome:*</label>
                  </Col>
                  <Col sm="10">
                    <input
                      id="Nome"
                      className="Requerido"
                      type="text"
                      placeholder="Nome"
                      onBlur={e => {
                        const cpo = document.getElementById("Nome").value;
                        if (cpo.length > 4)
                          document.getElementById("Nome").className = "Normal";
                        else
                          document.getElementById("Nome").className = "Requerido";
                      }}
                      value={nome}
                      onChange={event => setNome(event.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <label htmlFor="Email">E-mail:*</label>
                  </Col>
                  <Col sm="4">
                    <input
                      id="Email"
                      className="Requerido"
                      type="email"
                      placeholder="E-mail"
                      onBlur={e => {
                        if (email.length > 0)
                          document.getElementById("Email").className = "Normal";
                        else
                          document.getElementById("Email").className = "Requerido";
                      }}
                      value={email}
                      onChange={event => setEmail(event.target.value)}
                    />
                  </Col>
                  <Col sm="2">
                    <label htmlFor="CPF">CPF:*</label> 
                  </Col>
                  <Col sm="4">
                    <input
                      id="CPF"
                      className="Requerido"
                      type="text"
                      placeholder="CPF (só numeros)"
                      onBlur={e => {
                        if (cpf.length > 10)
                          document.getElementById("CPF").className = "Normal";
                        else
                          document.getElementById("CPF").className = "Requerido";
                      }}
                      value={cpf}
                      onChange={event => setCPF(event.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <label htmlFor="Instituicao">Instituição:*</label>
                  </Col>
                  <Col sm="4">
                    <input
                      id="Instituicao"
                      className="Requerido"
                      type="text"
                      placeholder="Instituição"
                      onBlur={e => {
                        const cpo = document.getElementById("Instituicao").value;
                        if (cpo.length > 0)
                          document.getElementById("Instituicao").className =
                            "Normal";
                        else
                          document.getElementById("Instituicao").className =
                            "Requerido";
                      }}
                      value={instituicao}
                      onChange={event => setInstituicao(event.target.value)}
                    />
                  </Col>
                  <Col sm="2">
                  </Col>
                  <Col sm="4">
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <label htmlFor="Telefone">Telefone:*</label>
                  </Col>
                  <Col sm="4">
                    <input
                      id="Telefone"
                      className="Requerido"
                      type="tel"
                      placeholder="Telefone"
                      onBlur={e => {
                        const cpo = document.getElementById("Telefone").value;
                        if (cpo.length > 5)
                          document.getElementById("Telefone").className = "Normal";
                        else
                          document.getElementById("Telefone").className =
                            "Requerido";
                      }}
                      value={telefone}
                      onChange={event => setTelefone(event.target.value)}
                    />
                  </Col>
                  <Col sm="2">
                    <label htmlFor="Celular">Celular:</label>
                  </Col>
                  <Col sm="4">
                    <input
                      id="Celular"
                      className="Normal"
                      type="tel"
                      placeholder="Celular"
                      value={celular}
                      onChange={event => setCelular(event.target.value)}
                    />
                  </Col>
                </Row>
                <Row className={mensagem ? "mostrar" : "naoMostrar"}>
                  <Col sm="12">
                    <Alert variant={tipoMensagem}>
                        {mensagem}
                    </Alert>
                  </Col>
                </Row>
                <Row>
                <Col sm={12} className="linhaBotao">
                  <Button variant="secondary" onClick={handleCancelar}>Cancelar</Button>
                  <Button variant="success" onClick={handleAEnviarNovo} disabled={enviando}>Enviar</Button>
                </Col>
                </Row>
                <Row>
                  <Col sm="12" className="observacao">
                    Os itens marcados com <strong>*</strong> (asterisco) são obrigatórios!
                  </Col>
                </Row>
              </div>
              <div className={avisoEmail? "quadro mostrar":"quadro naoMostrar"}>
                <Row>
                    <Col sm="12">
                      <b>Obrigado por sua inscrição para participação!</b><br /><br />
                      Um e-mail com seu n° de confirmação foi enviado para seu endereço de e-mail,<br />
                      informe este n° para confirmar sua inscrição e poder contribuir.<br />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <Button variant="info" onClick={hancleConfirmar}>Confirmar a inscrição</Button>
                    </Col>
                  </Row>
              </div>
            </form>
        </Container>
      </>
    );
}
